import { Stack, Typography } from "@the-game/components";
import { breakpoint, calcRem } from "@the-game/components/utils";
import styled from "@emotion/styled";
export const StyledRecaptcha = styled(Typography)(({ theme }) => ({
  color: theme.colors.palette.neutral70,
  marginBottom: 0,
  a: {
    color: theme.colors.palette.neutral70
  }
}));
export const StyledOr = styled("div")(({ theme }) => ({
  height: "2rem",
  display: "grid",
  alignItems: "center",
  justifyContent: "center",
  gridTemplateColumns: "1fr 3rem 1fr",
  width: "100%",
  hr: {
    color: theme.colors.palette.neutral30,
    backgroundColor: theme.colors.palette.neutral30,
    borderColor: theme.colors.palette.neutral30,
    width: "100%"
  },
  span: {
    justifySelf: "center"
  }
}));
export const StyledInlineRegistrationContainer = styled(Stack)(({ theme }) => ({
  span: {
    fontSize: calcRem(19),
    fontWeight: theme.weights.bold
  },
  width: "100%",
  [breakpoint("lg")]: {
    span: {
      fontSize: calcRem(21)
    }
  }
}));
